// extracted by mini-css-extract-plugin
module.exports = {"switch":"switch_switch__IPDjC","checkbox":"switch_checkbox__X1aoH","switch_checked":"switch_switch_checked__viuzt","handle":"switch_handle__dKuFC","inner":"switch_inner__hEvi4"};